import React from "react";
import * as styles from "./HeaderMenuDropdown.module.scss";
import MenuItemHeadline from "./MenuItemHeadline/MenuItemHeadline";
import MenuItemTile from "./MenuItemTile/MenuItemTile";

function SupportMenuDropdown() {
  return (
    <div className={styles.root}>
      <div className={styles.mainPartTiles}>
        <MenuItemHeadline>New to Fibery?</MenuItemHeadline>
        <div className={styles.mainTiles}>
          <MenuItemTile
            iconName={"oxford-cap"}
            color={"#FFC300"}
            name={"Getting started"}
            href={"/getting-started"}
            description={"Explore educational materials for every stage of tool adaptation."}
          />
          <MenuItemTile
            iconName={"live-help"}
            color={"#13CF14"}
            name={"Expert help"}
            href={"/expert-help"}
            description={"Choose your favorite format: read a guide, talk to a human, or just chat with AI."}
          />
          <MenuItemTile
            iconName={"tv"}
            color={"#FA3C4D"}
            name={"Webinars & tutorials"}
            href={"/webinars/"}
            description={"Watch our previous webinars or book a personal demo."}
          />
        </div>
      </div>
      <div className={styles.additionalPartLinks}>
        <div className={styles.additionalPartGroup}>
          <MenuItemHeadline>Learn more</MenuItemHeadline>
          <div className={styles.menuItemsGroup}>
            <div className={styles.menuSingleItem}>
              <a
                className={styles.dropdownLink}
                href="https://help.fibery.io/"
                target={"_blank"}
              >
                User Guide
              </a>
            </div>
            <div className={styles.menuSingleItem}>
              <a className={styles.dropdownLink} href="/blog/">
                Blog
              </a>
            </div>
          </div>
        </div>
        <div className={styles.additionalPartGroup}>
          <MenuItemHeadline>Enterprise-level security</MenuItemHeadline>
          <div className={styles.menuItemsGroup}>
            <div className={styles.menuSingleItem}>
              <a className={styles.dropdownLink} href="/security">
                Security & privacy
              </a>
            </div>
            <div className={styles.menuSingleItem}>
              <div className={styles.badges}>
                <a href="/security">
                  <img src={"https://images-temp.fibery.io/website-static/common/soc2.svg"} alt={"soc2"} />
                </a>
                <a href="/security">
                  <img src={"https://images-temp.fibery.io/website-static/common/gdpr.svg"} alt={"gdpr"} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupportMenuDropdown;
